import "../layouts/default";
import "../common/smartform";
import { addRules } from "Components/form/validate-methods";

$(function () {
    $(".js-form-lost-password").validate({
        submitHandler: function (form) {
            window.assignRecaptchaResponseToForm(form).then(() => {
                form.submit();
            });
        },
    });

    setTimeout(() => {
        for (const formElem of document.querySelectorAll(".js-form-reg-b2c")) {
            addRules(formElem, ["addressInputs"]);
        }

        for (const formElem of document.querySelectorAll(".js-form-reg-b2b")) {
            addRules(formElem, ["addressInputs"]);
        }
    }, 250);
});

const assignHiddenFields = (autocompleteField, data) => {
    const form = autocompleteField.closest("form");
    const billing = form.querySelector(".js-b2b-reg-billing");

    if (billing) {
        billing.classList.remove("h-nodisplay");

        if (Object.values(data.result || []).length) {
            for (const input of billing.querySelectorAll("input, select")) {
                $(input).valid();
            }
        }
    }
};

const checkSbl = (data) => {
    var name = data.result.Name;

    $.ajax({
        url: "/custom-find-sbl?company=" + name,
        dataType: "json",
        timeout: 6000,
        success: function (data) {
            if (data.result && data.custom_selling_permission) {
                if (document.querySelector(".js-checkbox-b2b")) {
                    document.querySelector(".js-checkbox-b2b").checked = 1;
                    document.querySelector(".js-business-permission").classList.remove("hidden");

                    if (document.querySelector(".js-registration-checkbox")) {
                        document.querySelector(".js-registration-checkbox").checked = true;

                        $(".js-registration-checkbox").trigger("change");
                        $(".js-registration-checkbox-holder").toggleClass("hidden", true);
                    }
                }

                if (document.querySelector(".js-selling-permission")) {
                    document.querySelector(".js-selling-permission").disabled = false;
                    document.querySelector(".js-selling-permission").value =
                        data.custom_selling_permission;
                }
            } else {
                console.log(
                    'Error: Cannot find selling permission for "' + name + '" in our database.'
                );
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.log("Error: There was problem with ajax request");
        },
    });
};

rEvent.on("Finstat.select.after", (autocompleteField, data) => {
    assignHiddenFields(autocompleteField, data);
    checkSbl(data);
});
